/* eslint-disable no-useless-escape */
export const SelectMenuTypes = {
  SINGLE_SELECTION: 'singleSelection',
  MULTI_SELECTION: 'multiSelection',
  FOLDER_SINGLE_SELECTION: 'folderSingleSelection',
  FOLDER_MULTI_SELECTION: 'folderMultiSelection'
};
export const SelectOptionTypes = {
  GROUP_LIST: 'groupList',
  FOLDER_LIST: 'folderList'
};
export const defaultSelectedValue = placeHolder => ({
  label: placeHolder,
  value: ''
});
export const removePlaceholder = function () {
  let selectedValues = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  let placeHolder = arguments.length > 1 ? arguments[1] : undefined;
  return selectedValues.filter(_ref => {
    let {
      label
    } = _ref;
    return label != placeHolder;
  });
};